import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Avatar, IconButton, Tooltip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { logoutUser } from './actions/userActions';
import ProfileDialog from '../ProfileDialog/ProfileDialog';

/**
 * UserProfile - פרופיל משתמש עם אפשרות התנתקות ועריכת פרטים
 *
 * @param {object} user - מידע על המשתמש (displayName, email, photoURL)
 * @param {object} organization - נתוני הארגון
 * @param {function} dispatch - Redux dispatch
 */
const UserProfile = ({ dispatch, user, organization }) => {
    const navigate = useNavigate();
    const [profileDialogOpen, setProfileDialogOpen] = useState(false);

    const handleLogout = async () => {
        try {
            await dispatch(logoutUser());
            navigate('/', { replace: true });
        } catch (error) {
            console.error('Error during logout:', error);
        }
    };

    if (!user) return null;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {/* פרופיל משתמש - לחיץ */}
            <Box
                onClick={() => setProfileDialogOpen(true)}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    p: 1.5,
                    bgcolor: 'rgba(255,255,255,0.05)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    borderRadius: '10px',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    '&:hover': {
                        bgcolor: 'rgba(255,255,255,0.10)',
                        borderColor: 'rgba(255,255,255,0.15)',
                    },
                }}
            >
                <Avatar
                    src={user.photoURL}
                    alt={user.displayName}
                    sx={{
                        width: 36,
                        height: 36,
                        border: '2px solid rgba(154,114,9,0.35)',
                        boxShadow: '0 0 0 2px rgba(154,114,9,0.12)'
                    }}
                >
                    {user.displayName?.charAt(0) || user.email?.charAt(0)}
                </Avatar>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 500,
                            color: 'white',
                            fontSize: '0.75rem',
                            lineHeight: 1.2
                        }}
                        noWrap
                    >
                        {user.displayName || 'משתמש'}
                    </Typography>
                    {user.email && (
                        <Typography
                            variant="caption"
                            sx={{
                                color: 'rgba(255,255,255,0.6)',
                                fontSize: '0.65rem',
                                lineHeight: 1.2
                            }}
                            noWrap
                        >
                            {user.email}
                        </Typography>
                    )}
                </Box>
            </Box>

            {/* כפתור התנתקות */}
            <Tooltip title="התנתק">
                <IconButton
                    onClick={handleLogout}
                    fullWidth
                    sx={{
                        color: 'rgba(255,255,255,0.6)',
                        bgcolor: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(255,255,255,0.08)',
                        borderRadius: '8px',
                        py: 1,
                        transition: 'all 0.2s',
                        '&:hover': {
                            color: '#F87171',
                            bgcolor: 'rgba(248,113,113,0.08)',
                            borderColor: 'rgba(248,113,113,0.22)',
                        },
                        display: 'flex',
                        gap: 1,
                        justifyContent: 'flex-start'

                    }}
                >
                    <LogoutIcon fontSize="small" />
                    <Typography variant="body2" sx={{ fontSize: '0.9rem' }}>
                        התנתק
                    </Typography>
                </IconButton>
            </Tooltip>

            {/* דיאלוג פרטים אישיים */}
            <ProfileDialog
                open={profileDialogOpen}
                onClose={() => setProfileDialogOpen(false)}
                organization={organization}
                user={user}
                dispatch={dispatch}
            />
        </Box>
    );
};

export default UserProfile;
